import React from 'react';
import classNames from 'classnames';
import Data from './model/Data';
// common components
import Preloader from './common/components/Preloader/Preloader';
import setCustomVw from './common/helpers/custom-vw';
import minWidthViewport from './common/helpers/min-width-viewport';
import UtmController from './common/components/UtmReader/UtmReader';

interface Props {
  className?: string;
}

class AppWrapper extends React.Component<Props, { isLoaded: boolean, hasError: boolean }> {

  private currentClass = 'app-wrapper';

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoaded: false,
      hasError: false,
    }
  }

  componentDidMount(): void {
    minWidthViewport();
    setCustomVw();
    window.addEventListener('resize', setCustomVw);
    Data.load().then((response) => {
      Data.Instance.update(response.data);
      this.setState({ isLoaded: true });
    }).catch((err) => {
      Sentry.captureException(err);
      this.setState((prevState) => ({ ...prevState, hasError: true }))
    });
    
    // Collect Utm-metrics, if given so
    UtmController.collectMetrics(window.location.search)
    
    if (!/Prerender/.test(navigator.userAgent)) {
      // Add Google Analytics
      // <script async src="https://www.googletagmanager.com/gtag/js?id=<%GA_TOKEN%>"></script>
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=<%GA_TOKEN%>";
      script.async = true;
      document.body.appendChild(script);
    }
  }
  
  componentWillUnmount(): void {
    window.removeEventListener('resize', setCustomVw);
  }

  render(): JSX.Element {
    const { children, className } = this.props;
    const { isLoaded, hasError } = this.state;
    const klass = { [this.currentClass]: true };
    let child;

    if (className) klass[className] = true;

    if (!hasError) {
      child = isLoaded ? children : <Preloader />
    } else {
      // TODO: insert alert component
      child = <div className="error">Sorry, but something went wrong</div>
    }

    return (
      <div className={classNames(klass)}>
        { child }
      </div>
    );
  }
}

export default AppWrapper;
